import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const Admin_Menu_Edit = () => {
  
  const { sNo } = useParams();
  const [subDetails, setSubDetails] = useState({});
  const [dept, setDept] = useState([]);
  const [subDept, setSubDept] = useState([]);
  const [formData, setFormData] = useState({title: "", order: "", link: "", subDepartment: "", dept: ""});
  const navigate = useNavigate();
    

  const handleGoBack = () => {
    navigate(-1); 
  };

  useEffect(() => {
  const fetchAllMenuData = async () => {
    let progress = 0;

    const updateProgress = (value) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${value}%`;
      if (text) text.innerText = `Loading... ${value}%`;
    };

    Swal.fire({
      title: "Loading Menu Details",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      // Step 1: Fetch Department List
      const deptRes = await axios.get("https://rfs2.infraconsoft.net.in/api/adminMenu_Deptlist");
      setDept(deptRes.data.dept || []);
      progress = 33; updateProgress(progress);

      // Step 2: Fetch SubDepartment List
      const subDeptRes = await axios.get("https://rfs2.infraconsoft.net.in/api/adminMenu_subDeptlist");
      setSubDept(subDeptRes.data.subDept || []);
      progress = 66; updateProgress(progress);

      // Step 3: Fetch Supplier/Menu Details (if sNo is valid)
      if (sNo) {
        const supplierRes = await axios.get(`https://rfs2.infraconsoft.net.in/api/adminMenu_editFetch?slNo=${sNo}`);
        const items = supplierRes.data.fetchData || [];

        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            title: item.title || "N/A",
            order: item.orders || "N/A",
            link: item.links || "0",
            subDepartment: item.subdepartment || "0",
            dept: item.department || "0",
          };

          setSubDetails(storeReqHeader1);
          setFormData({
            dept: storeReqHeader1.dept,
            subDept: storeReqHeader1.subDepartment,
            title: storeReqHeader1.title,
            link: storeReqHeader1.link,
            order: storeReqHeader1.order,
          });
        }
      }

      progress = 100; updateProgress(progress);
      setTimeout(() => Swal.close(), 500);

    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Load Failed",
        text: "An error occurred while loading data.",
      });
    }
  };

  fetchAllMenuData();
}, [sNo]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    title: formData.title,
    dept: formData.dept,
    subDept: formData.subDept,
    link: formData.link,
    order: formData.order,
    slNo: sNo,
  };

  console.log("Submitting Payload:", payload);

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      "https://rfs2.infraconsoft.net.in/api/adminMenuList_edit",
      payload
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message,
      timer: 1500,
      showConfirmButton: false,
    }).then(() => {
      navigate(-1); // 👈 goes back to previous page automatically
    });
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire("Error", error.response.data.message, "error");
    } else {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  }
};

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
      <h2 className="add-txt">Menu - Edit</h2>
      <p className="back-button" onClick={handleGoBack} style={{ cursor: 'pointer' }}>
        <i className="fa-solid fa-backward"></i> Back
      </p>
    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
          <div className="form-group">
                <label>Department :</label>
                <select name="dept"  value={formData.dept}  onChange={handleInputChange} >
            <option value="">Select Dept</option>
            {dept.map((item) => (
              <option key={item.department} value={item.department}>
                {item.department}
              </option>
            ))}
          </select>
              </div>
              <div className="form-group">
                <label>Sub Department :</label>
                <select name="subDept"  value={formData.subDept}  onChange={handleInputChange} >
            <option value="">Select Sub Department</option>
            {subDept.map((item) => (
              <option key={item.subdepartment} value={item.subdepartment}>
                {item.subdepartment}
              </option>
            ))}
          </select>
              </div>
            </div>




          <div className="form-row">
              <div className="form-group">
                <label>Title :</label>
                <input type="text" name="title" value={formData.title} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Link Page :</label>
                <input type="text" name="link" value={formData.link} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Orders:</label>
                <input type="text" name="order" value={formData.order} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>

          
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Admin_Menu_Edit;
